import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitorSquadPageRouteMetaDataModel extends CompetitorPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITOR.squad)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITOR.squad)
    }

    return description
  }

  get staticTitle() {
    const title = this.websiteTerms.WEB_COMPETITOR_SQUAD_TITLE_TEMPLATE.format({
      "COMPETITOR_NAME": this.competitorName,
      "WEB_COMPETITOR_SQUAD_TERM_IN_TITLE": this.websiteTerms.WEB_COMPETITOR_SQUAD_TERM_IN_TITLE
    });

    return this.titleFormatTerm(title)
  }

  get staticDescription() {
    const description = this.websiteTerms.WEB_COMPETITOR_SQAUD_DESCRIPTION_TEMPLATE.format({
      "COMPETITOR_NAME": this.competitorName
    });

    return this.descriptionFormatTerm(description)
  }
}